import Checkbox from '@picsart/checkbox/Checkbox';
import { useFormikContext } from 'formik';

import TextLabel from '../TextLabel/TextLabel';
import tooltipStyles from '../tooltipStyles';
import analytics from '../../../services/analytics';
import { getCategoryName } from '../../../utils/common/category';

import useStyles from './styles';
import { GenericCheckboxProps } from './types';

function GenericCheckbox({
  name,
  formProps,
  textLabel,
  selectedCategory,
  information,
  analyticsName,
  tooltipProps,
}: GenericCheckboxProps) {
  const { setFieldValue } = useFormikContext();
  const classes = useStyles();
  const tooltipClasses = tooltipStyles({ tooltipProps });
  const selected: boolean = formProps.values[name];

  const handleSelect = () => {
    analytics.textBoxClick({
      text_box_name: analyticsName,
      category_name: getCategoryName(selectedCategory),
      page_path: window.location.pathname,
    });
    setFieldValue(name, !selected);
  };

  return (
    <div className={classes.root}>
      <Checkbox isChecked={selected} onChange={handleSelect}></Checkbox>
      <TextLabel
        tooltipClassName={tooltipClasses.tooltip}
        arrowClassName={tooltipClasses.tooltipArrow}
        required={false}
        htmlFor={name}
        label={textLabel}
        infoText={information}
      />
    </div>
  );
}
export default GenericCheckbox;
